// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"wK-z","carouselContainer":"xK-z"};